import React, { useState, useEffect } from 'react';

import { Container, ThisCol, ThisCard, ThisCardColor, ScrollOS } from './styles';
import api from "~/services/api";

import IconGroup from '~/assets/icones/IconGroup.svg';
import IconMax from '~/assets/icones/IconMax.svg';

function CustomBodyContent({ data }) {
  const [linhaAtiva, setLinhaAtiva] = useState([]);
  const [etapas, setEtapas] = useState([]);

  useEffect(() => {
    api.get("/signed/empresa/gestorprojeto/etapa/etapas", { params: { ativo: 1, tipo: 'ORC' } }).then((r) => setEtapas(r?.data));
  }, []);

  return (
    <Container>
      <div className="content-oc">
        <ScrollOS>
          <div className="display-oc">
            {etapas?.map((thisEtapa, i) => (
              <ThisCol
                key={thisEtapa?.id || i}
                id={thisEtapa?.id || i}
                index={i}
              >
                <div className="list-header">
                  {/* <img src={IconGroup} alt="Vazio" /> */}
                  <p className="titulo">{thisEtapa?.titulo}</p>
                  <img className="max" src={IconMax} alt="Vazio" />
                </div>
                <div className="line"></div>
                <div className="list-body">
                  {
                    data?.map((thisData, i) => thisData?.idEtapa == thisEtapa?.id && (
                      <ThisCard
                        className={linhaAtiva === thisData?.id ? 'card-item ativo' : 'card-item'}
                        {...{ data: thisData, linhaAtiva, setLinhaAtiva }}
                        key={thisData?.id || i}
                        id={thisData?.id || i}
                        index={i}
                        ativo={linhaAtiva === thisData?.id ? true : false}
                      >
                        <div className="card-header">
                          <div className="card-header-top">
                            <p className="codigo">#{thisData?.codigo}</p>
                            <p className="data">{((new Date(thisData?.dataSolicitacao).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0]}</p>
                          </div>
                          <p className="titulo">{thisData?.titulo}</p>
                          <p className="cliente">{thisData?.cliente?.nomeFantasia}</p>
                        </div>
                        <div className="card-footer">
                          <div className="card-footer-priori">
                            <ThisCardColor cor={thisData?.prioridade?.cor} />
                            <p className="titulo">{thisData?.prioridade?.titulo}</p>
                          </div>
                          <p className="responsavel">Coord.: {thisData?.coordenador?.nome}</p>
                        </div>
                      </ThisCard>
                    ))
                  }
                </div>
              </ThisCol>
            ))}
          </div>
        </ScrollOS>
      </div>
    </Container>
  );
}

export default CustomBodyContent;
